<template>
  <div>
    <div>
      <s-table
        :fields="headers"
        :items="items"
        :busy="loading"
        :sort-by="sortBy"
        :sort-desc="sortDirection"
      >
        <template #cell(view-network)="items">
          <b-button
            size="lg"
            flat
            @click="goToInstallationNetworks(items.item.instalacaoId)"
          >
            <b-img src="/static/imgs/items.png" />
          </b-button>
        </template>
        <template #cell(actions)>
          <b-dropdown
            variant="link"
            offset="-25"
            right
            no-caret
            class="action-list_options-btn"
          >
            <template slot="button-content">
              <i
                aria-hidden="true"
                class="fas fa-ellipsis-v text-gray align-center"
              />
            </template>
            <b-dropdown-item>
              <span class="fa fa-upload action-list__option-icon" />
              <span>{{ $t('network-management.action-list.apply') }}</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <span class="fas fa-edit action-list__option-icon" />
              <span>{{ $t('network-management.action-list.edit') }}</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <span class="fa fas fa-pencil-alt action-list__option-icon" />
              <span>{{
                $t('network-management.action-list.modify-status')
              }}</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <span class="far fa-trash-alt action-list__option-icon red" />
              <span class="red">{{
                $t('network-management.action-list.remove')
              }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </s-table>
      <grid-paginator
        v-model="currentPageProxy"
        :per-page="perPage"
        :total-rows="totalRows"
        @input="paging($event)"
      />
    </div>
  </div>
</template>

<script>
import NetworkManagementTableFields from '@/domain/data/generalPanel/networkManagement/networkManagementTableFields';
import GridPaginator from '@/components/lists/Paginator';

export default {
  name: 'NetworkManagementTable',
  components: {
    GridPaginator,
  },
  props: {
    items: Array,
    currentPage: Number,
    totalRows: Number,
    perPage: Number,
    sortBy: String,
    sortDirection: String,
    loading: Boolean,
  },
  methods: {
    goToInstallationNetworks(instalacaoId) {
      const routeData = this.$router.resolve({
        name: 'network-management-installation',
        params: {
          instalacaoId,
        },
      });
      window.open(routeData.href, '_self');
    },
    paging($event) {
      this.$emit('paging', $event);
    },
  },
  computed: {
    headers() {
      return NetworkManagementTableFields.getHeaders(this);
    },
    currentPageProxy: {
      get() {
        return this.currentPage;
      },
      set(value) {
        this.$emit('update:currentPage', value);
      },
    },
  },
};
</script>
<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
.s-table
  min-height: 150px
  overflow: auto
.action-list
  &__captalized
    text-transform: capitalize
  &__options-btn
    margin: -10px 0
  &__option-icon
    margin-right: 5px
.red
  color: red

  +media-min-sm()
  +media-min-md()
  +media-min-lg()
</style>
